import { computed, Ref, ref } from 'vue'
import { defineStore } from 'pinia'
import { Network } from '@ezio/features/networks/types'
import { BaseError, objectify } from '@ezio/utils'
import { useEzioAPI } from '@ezio/services'

export const useNetworksStore = defineStore('networks', () => {
    const { api } = useEzioAPI()

    const all: Ref<{ [id: string]: Network }> = ref({})
    const indexByName = ref<Network[]>([])

    const fetchCollection = async () => {
        const response = await api.get('companies', {
            pagination: false
        })
        storeIndex(response.data)
    }
    const fetch = async (id: string) => {
        const response = await api.get('companies/' + id, {
            include: 'agencies'
        })
        store([response.data])
    }

    const create = async (data: any) => {
        try {
            const response = await api.post('companies', data)
            // should store the response but getCollection is OK for now
            store([response.data])
            updateIndex(response.data)
            return response.data
        } catch (error: any) {
            throw new BaseError({
                title: 'Oups !',
                message: error.message
            })
        }
    }

    const update = async (network: Network) => {
        try {
            const params = Object.assign(
                {
                    include: 'agencies'
                },
                network
            )
            const response = await api.put('companies/' + network.id, params)
            store([response.data])
            updateIndex(response.data)
            return response.data
        } catch (error: any) {
            throw new BaseError({
                title: 'Oups !',
                message: error.message
            })
        }
    }

    const createOrUpdate = async (data: any) => {
        if (data.id) {
            return await update(data)
        } else {
            return await create(data)
        }
    }

    const updateIndex = (network: Network) => {
        const temp = indexByName.value.slice()
        const idx = temp.findIndex((c) => network.id === c.id)
        if (idx > -1) {
            temp[idx] = network
        } else {
            temp.push(network)
        }
        temp.sort(sortByName)
        indexByName.value = temp
    }
    const storeIndex = (networks: Network[]) => {
        indexByName.value = networks
        indexByName.value.sort(sortByName)
    }

    // const storeCollection = (networks: Network[]) => {
    //     all.value = objectify(networks)
    //     byName.value = networks.map((c) => c.id)
    // }
    const store = (networks: Network[]) => {
        all.value = Object.assign({}, all.value, objectify(networks))
    }

    const reset = () => {
        all.value = {}
        indexByName.value = []
    }

    const sortByName = (A, B) => {
        const nameA = A.name
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')

        const nameB = B.name
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')

        if (nameA < nameB) {
            return -1
        }
        if (nameA > nameB) {
            return 1
        }
        return 0
    }

    return {
        all,
        byName: indexByName,
        fetch,
        fetchCollection,
        createOrUpdate,
        reset
    }
})
